/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDollarNote = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-dollar-note_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-dollar-note_svg__st0"
      d="M10 13h1v2H8v2h3v1h2v-1h1c1.7 0 3-1.3 3-3s-1.3-3-3-3h-1V9h3V7h-3V6h-2v1h-1c-1.7 0-3 1.3-3 3s1.3 3 3 3zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1h-1v-2zm-3-4h1v2h-1c-.6 0-1-.4-1-1s.4-1 1-1z"
    />
    <path className="ico-dollar-note_svg__st0" d="M0 3v18h24V3H0zm22 16H2V5h20v14z" />
  </Icon>
);
export { SvgDollarNote as DollarNote };
